var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9814 13.9136C14.9814 14.4624 14.5364 14.9074 13.9876 14.9074H1.0678C0.518925 14.9074 0.0739746 14.4624 0.0739746 13.9136C0.0739746 13.3647 0.518925 12.9197 1.0678 12.9197H13.9876C14.5364 12.9197 14.9814 13.3647 14.9814 13.9136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03697 4.96914V1.98765H21.9382V25.8395H6.03697V22.8581H4.04932V26.8333C4.04932 27.097 4.15403 27.3497 4.3404 27.5361C4.52678 27.7225 4.77957 27.8271 5.04315 27.8271H22.9321C23.1956 27.8271 23.4484 27.7225 23.6348 27.5361C23.8211 27.3497 23.9259 27.097 23.9259 26.8333V0.993827C23.9259 0.730249 23.8211 0.477463 23.6348 0.291085C23.4484 0.104706 23.1956 0 22.9321 0H5.04315C4.77957 0 4.52678 0.104706 4.3404 0.291085C4.15403 0.477463 4.04932 0.730249 4.04932 0.993827V4.96914H6.03697Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30964 18.5917C8.92153 18.2035 8.92153 17.5742 9.30964 17.1862L13.2849 13.2108C13.6731 12.8228 14.3024 12.8228 14.6904 13.2108C15.0786 13.599 15.0786 14.2283 14.6904 14.6163L10.7151 18.5917C10.327 18.9797 9.69775 18.9797 9.30964 18.5917Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6904 14.6163C14.3024 15.0045 13.6731 15.0045 13.2849 14.6163L9.30964 10.641C8.92153 10.2529 8.92153 9.62366 9.30964 9.23555C9.69775 8.84743 10.327 8.84743 10.7151 9.23555L14.6904 13.2108C15.0786 13.599 15.0786 14.2282 14.6904 14.6163Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04315 24.8457C4.49427 24.8457 4.04932 24.4008 4.04932 23.8519V21.8642C4.04932 21.3154 4.49427 20.8704 5.04315 20.8704C5.59202 20.8704 6.03697 21.3154 6.03697 21.8642V23.8519C6.03697 24.4008 5.59202 24.8457 5.04315 24.8457Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04315 6.95682C4.49427 6.95682 4.04932 6.51187 4.04932 5.96299V3.97533C4.04932 3.42646 4.49427 2.98151 5.04315 2.98151C5.59202 2.98151 6.03697 3.42646 6.03697 3.97533V5.96299C6.03697 6.51187 5.59202 6.95682 5.04315 6.95682Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.7df04706966dfdfb6a81a127f4a9810c.svg";
export { ForwardRef as ReactComponent };